import { SUB_CATEGORIES } from '../../utils/categoriesEnum';

export const DISCLAIMERS = {
    [SUB_CATEGORIES.BUY_VIDEO_TESTIMONIALS]: {
        title: 'gig_page_perseus.disclaimer.spokesperson.title',
        description: 'gig_page_perseus.disclaimer.spokesperson.description'
    },
    [SUB_CATEGORIES.SPIRITUAL_AND_HEALING]: {
        title: 'gig_page_perseus.disclaimer.spiritual_healing.title',
        description: 'gig_page_perseus.disclaimer.spiritual_healing.description'
    },
    [SUB_CATEGORIES.ASTROLOGY_AND_READING]: {
        title: 'gig_page_perseus.disclaimer.astrology_reading.title',
        description: 'gig_page_perseus.disclaimer.astrology_reading.description'
    }
};
